module.exports = __webpack_public_path__ + "img/20190627162201108.3fc1a0a3.png";